<template>
    <div id="woerner-component" class="include-waiting">
        <div class="waiting" v-if="waiting == true">
            <i class="fa fa-rotate-right fa-spin"></i>
        </div>
        <div class="widget-fw bg-grey py-5 mt-4">
            <div class="container-max">
                <div class="row savecartrow mb-5 mb-lg-2" v-for="(item,index) in items">
                    <div class="col-12 col-lg-2">
                        <div class="bg-white-shadow mb-2">
                            <template v-if="item.variation.documents[0].data.images.variation.length > 0">
                                <img :src="item.variation.documents[0].data.images.variation[0].urlPreview" class="img-fluid">
                            </template>
                            <template v-else>
                                <img :src="item.variation.documents[0].data.images.all[0].urlPreview" class="img-fluid">
                            </template>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10">
                        <div class="row">
                            <div class="col-lg-6">
                                <a class="font-weight-bold" v-html="item.variation.documents[0].data.texts.name1" :href="'/'+item.variation.documents[0].data.texts.urlPath+'_'+item.variation.documents[0].data.item.id+'_'+item.variation.documents[0].data.variation.id"></a>
                                <ul v-if="item.variation.documents[0].data.attributes.length > 0" class="list-unstyled list-inline">
                                    <li v-for="attribut in item.variation.documents[0].data.attributes">
                                        <span class="font-weight-bold" v-html="attribut.attribute.names.name"></span>: <span v-html="attribut.value.names.name"></span>
                                    </li>
                                </ul>
                                <div class="text-muted small" v-html="item.variation.documents[0].data.variation.availability.names.name"></div>
                                <div class="m-t-1" v-html="item.variation.documents[0].data.prices.default.price.formatted"></div>
                            </div>
                            <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="qty-box">
                                                <input type="text" class="text-center" v-model.number="item.quantity" @change="miniQuantity(item.quantity,item.minimumOrderQuantity,index)"/>
                                            </div>
                                        </div>
                                        <div class="col-6 text-right">
                                            <button class="btn btn-primary d-inline-block" @click="savedCartItemToBasket(item)"><i class="fa fa-shopping-cart"></i></button>
                                            <button class="btn btn-secondary d-inline-block color-select-second m-l-1" @click="deleteFromList(items,index)"><i class="fa fa-close"></i></button>
                                        </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6 col-lg-2 offset-lg-8 text-left">
                        <template v-if="setitems.length === countsetitems">
                            <div>
                                <button class="btn btn-primary btn-block" @click="buySet()">
                                    {{ $translate("Woerner::Template.singleSetToBasket") }}

                                    <i aria-hidden="true" class="fa fa-shopping-cart" v-waiting-animation="waiting"></i>
                                </button>
                            </div>
                        </template>
                    </div>
                    <div class="col-md-6 col-lg-2  text-left" :class="{'offset-lg-10': setitems.length !== countsetitems }">
                        <div>
                            <button class="btn btn-primary btn-block" @click="listToBasket()">
                                {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                                <i aria-hidden="true" class="fa fa-shopping-cart" v-waiting-animation="waiting"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props:
            {
                template:
                {
                    type: String,
                    default: "#vue-woerner-setcomponent"
                },
            },
        inject:
            {
                itemId:
                {
                    default: null
                }
            },
        data: function()
        {
            return {
                daten: {},
                current:{},
                setitems: [],
                countsetitems:0,
                waiting:false,
                valueAllItems:0
            }
        },
        methods:
            {
                buySet:function()
                {
                    let data =
                    {
                        variationId:this.current.variation.id,
                        quantity:1,
                        totalOrderParamsMarkup:0,
                        setComponents:[],
                        template: "Ceres::Basket.Basket",
                        templateType: "item"
                    }

                    for(let i = 0; i < this.setitems.length; i++)
                    {
                        data.setComponents.push(
                            {
                                variationId:this.setitems[i].initialVariationId,
                                quantity:this.setitems[i].quantity,
                                totalOrderParamsMarkup:0,
                            }
                        )
                    }

                    $.ajax(
                {
                        type: 'POST',
                        url: '/rest/io/basket/items/',
                        data: data,
                        success: function (data)
                        {
                            CeresNotification.success(JSON.parse($('[data-translation="YbbaCartSave::Template"]')[0].innerHTML).notesArtikelhinzugefuegt).closeAfter(3000);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            // console.log(jqXHR);
                        }
                    })
                },
                listToBasket:function()
                {
                    let _self = this;
                    _self.waiting = true;
                    var variations = [];
                    for( var i = 0; i < this.setitems.length; i++)
                    {
                        variations.push(
                        {
                            "variationId": this.setitems[i].initialVariationId,
                            "quantity":this.setitems[i].quantity,
                            "name":this.setitems[i].variation.documents[0].data.texts.name1
                        });
                    }
                    var data = {
                        "items": variations
                    }
                    $.ajax({
                        type: 'POST',
                        url: '/cartsave/addtobasket/',
                        data: data,
                        success: function (data)
                        {
                            for( var i = 0; i < data.length; i++)
                            {
                                if(data[i].error)
                                {
                                    CeresNotification.error
                                    (
                                        JSON.parse($('[data-translation="YbbaCartSave::Template"]')[0].innerHTML).notesNichtgenugbestand.replace(':variationName',data[i].error.variationName).replace(':stock',data[i].error.placeholder.stock)
                                    );
                                }
                                else
                                {

                                    CeresNotification.success(JSON.parse($('[data-translation="YbbaCartSave::Template"]')[0].innerHTML).notesArtikelhinzugefuegt).closeAfter(3000);
                                }
                                if(i===data.length-1)
                                {
                                    vueApp.$store.commit("setBasketItems", data[i].basketItems);
                                    vueApp.$store.commit("setBasket", data[i].basket);
                                }
                            }
                            _self.waiting = false;
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            // console.log(jqXHR);
                        }
                    })
                },
                savedCartItemToBasket: function(item)
                {
                    let _self = this;
                    _self.waiting = true;
                    var variations = [];
                    variations.push(
                    {
                        "variationId": item.initialVariationId,
                        "quantity":item.quantity,
                        "name":item.variation.documents[0].data.texts.name1
                    });
                    var tosubmit =
                    {
                        "items": variations
                    }
                    $.ajax
                    (
                    {
                            type: 'POST',
                            url: '/cartsave/addtobasket/',
                            data: tosubmit,
                            success: function (data)
                            {
                                for (var i = 0; i < data.length; i++)
                                {
                                    if (data[i].error)
                                    {
                                        CeresNotification.error
                                        (
                                            JSON.parse($('[data-translation="YbbaCartSave::Template"]')[0].innerHTML).notesNichtgenugbestand.replace(':variationName',data[i].error.variationName).replace(':stock',data[i].error.placeholder.stock)
                                        );
                                    }
                                    else
                                    {

                                        CeresNotification.success(
                                            JSON.parse($('[data-translation="YbbaCartSave::Template"]')[0].innerHTML).notesArtikelhinzugefuegt
                                        ).closeAfter(3000);
                                    }
                                    if (i === data.length - 1)
                                    {
                                        vueApp.$store.commit("setBasketItems", data[i].basketItems);
                                        vueApp.$store.commit("setBasket", data[i].basket);
                                    }
                                }
                                _self.waiting = false;
                            },
                            error: function (jqXHR)
                            {
                                // console.log(jqXHR);
                            }
                        }
                    );
                },
                miniQuantity:function(quantity,min,index)
                {
                  if(quantity<min)
                  {
                      quantity = min;
                      this.setitems[index].quantity = min;
                  }
                  return quantity;
                },
                deleteFromList:function(items,index)
                {
                    items.splice(index,1);
                    this.calculatePricesOfItemsTogether();
                },
                calculatePricesOfItemsTogether:function()
                {
                    let _self = this;
                    let priceAll = 0;
                    let itemList = this.setitems;
                    // console.log(itemList);
                    for(let i = 0; i < itemList.length; i++)
                    {
                       // console.log('items?!');
                        //console.log(itemList[i]);
                        priceAll += itemList[i].variation.documents[0].data.prices.default.price.value;
                    }
                    _self.valueAllItems = priceAll;
                },
                getComponentsData: function()
                {
                    let SetVarIds = [];
                    if(this.setitems.length < 1)
                    {
                        this.current        = this.$store.getters[`${this.itemId}/currentItemVariation`];
                        this.daten          = this.$store.state.items;
                        this.countsetitems  = this.daten.setComponentIds.length;

                        for(let i = 0; i < this.daten.setComponentIds.length;i++)
                        {
                            this.setitems.push(this.daten[this.daten.setComponentIds[i]]);
                            for(let o = 0; o < this.current.setComponents.length; o++)
                            {
                               for(let t = 0; t < this.setitems.length; t++)
                               {
                                   if (this.current.setComponents[o].defaultVariationId === this.setitems[t].initialVariationId)
                                   {
                                       SetVarIds.push(this.current.setComponents[o].defaultVariationId);
                                       this.setitems[t].minimumOrderQuantity = this.current.setComponents[o].minimumOrderQuantity;
                                       this.setitems[t].quantity             = this.current.setComponents[o].minimumOrderQuantity;
                                       this.setitems[t].maximumOrderQuantity = this.current.setComponents[o].maximumOrderQuantity;
                                   }
                               }
                            }
                        }
                        let items = this.setitems;
                        let _self = this;
                        if(SetVarIds.length > 0)
                        {
                            $.ajax(
                        {
                                type: 'POST',
                                url: '/itemsList/',
                                data: { "items":SetVarIds },
                                success: function (data)
                                {
                                    if(data.length > 0)
                                    {
                                        _self.valueAllItems = 0;
                                        for(let i = 0; i < data.length; i++)
                                        {
                                            for(let s = 0; s < items.length; s++)
                                            {
                                                if(items[s].initialVariationId == data[i].id)
                                                {

                                                    items[s].normalData =  data[i].data;
                                                    _self.valueAllItems += data[i].data.prices.default.price.value;
                                                }
                                            }
                                        }
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    // console.log(jqXHR);
                                }
                            })
                        }
                    }
                }
            },
        computed:
        {
            items: function()
            {
                this.getComponentsData();
                return this.setitems
            }
        }
    }
</script>
